<script>
import { componentStore } from "@common/componentStore/componentStore";
import { library } from "@common/library/library";
import { recordStore } from "@common/recordStore";

const globalHierarchyFiltersConfig = {
    cId: "globalHierarchyFilters",
    cType: "globalHierarchyFilters",
    cTitle: "Global Hierarchy Filters",
    cTemplate: `<div class="global-hierarchy-filters">
                    <control name="GLOBAL_HIERARCHY_FILTER" :value="selectedGlobalHierarchy" :items="globalHierarchyItems" @update:value="selectedGlobalHierarchy = $event"></control>
                </div>`,
    controls: [
        {
            name: 'GLOBAL_HIERARCHY_FILTER',
            type: 'multiselect',
            ref: 'GLOBAL_HIERARCHY_FILTER',
            allowFiltering: true,
            filterType: 'Contains',
            allowMultiSelection: true,
            hideSelectedItem: false,
            closePopupOnSelect: false,
            fields: {
                text: 'title',
                value: 'id',
                groupBy: 'groupTitle'
            },
            default: [],
            onchange: 'filterChanged',
            valueTemplate: `<span>{{data.groupTitle}}: {{data.title}}</span>`
        },
    ]
};

let globalHierarchyFiltersCmp = {
    name: 'globalHierarchyFilters',
    props: {
    },
    data() {
        return {
            initialGlobalHierarchyItems: [],
            globalHierarchyItems: [],
            selectedGlobalHierarchy: [],
            selectedByGroup: {},
            filters: {
                'PROGRAM': 'Program',
                'LOCATION': 'Location',
                'ENTRY_POINT': 'Entry Point',
            }
        };
    },
    computed: {},
    methods: {
        async onLoad() {
            this.sDs.post('ec_getHierarchyFilterList').then((response) => {
                if (response && response.status === 'success') {
                    let filterItems = [];
                    let selectedGlobalHierarchy = [];
                    for (let key in this.filters) {
                        let groupTitle = this.filters[key];
                        if (Array.isArray(response.data[key]) && response.data[key].length) {
                            let tmpSelected = response.data[key].find((tmp) => tmp.selected);
                            if (tmpSelected) selectedGlobalHierarchy.push(key + '_' + tmpSelected.id);
                            let tmpItems = library.cloneObj(response.data[key]);
                            tmpItems = tmpItems.map((tmp) => {
                                tmp.id = key + '_' + tmp.id; // prevent same id
                                tmp.groupTitle = groupTitle;
                                tmp.groupName = key;
                                return tmp;
                            });
                            filterItems = [...filterItems, ...tmpItems];
                        }
                    }
                    if (Array.isArray(filterItems) && filterItems.length) {
                        this.selectedGlobalHierarchy = selectedGlobalHierarchy;
                        this.initialGlobalHierarchyItems = library.cloneObj(filterItems);
                        this.hideItems();
                    }
                }
            });
        },
        getSelectedByGroup() {
            let value = this.selectedGlobalHierarchy || [];
            let selected = {};
            for (let key in this.filters) {
                selected[key] = 0;
                let tmpValue = value.find((tmp) => tmp.indexOf(key + '_') !== -1);
                if (tmpValue) tmpValue = tmpValue.replace(key + '_', '');
                if (parseInt(tmpValue, 10) > 0) {
                    selected[key] = parseInt(tmpValue, 10);
                }
            }
            return selected;
        },
        hideItems() {
            this.selectedByGroup = this.getSelectedByGroup();
            let value = this.selectedGlobalHierarchy || [];
            let hideGroups = [];
            for (let key in this.filters) {
                if (this.selectedByGroup[key]) {
                    switch (key) {
                        case 'ENTRY_POINT':
                            hideGroups = [...hideGroups, ...['LOCATION', 'PROGRAM']];
                            break;
                        case 'LOCATION':
                            hideGroups = [...hideGroups, ...['ENTRY_POINT', 'LOCATION']];
                            break;
                        case 'PROGRAM':
                            hideGroups = [...hideGroups, ...['ENTRY_POINT', 'PROGRAM']];
                            break;
                    }
                }
            }
            let globalHierarhyItems = [];
            for (let i in this.initialGlobalHierarchyItems) {
                if (
                    value.indexOf(this.initialGlobalHierarchyItems[i].id) !== -1
                    || hideGroups.indexOf(this.initialGlobalHierarchyItems[i].groupName) === -1
                ) {
                    globalHierarhyItems.push(library.cloneObj(this.initialGlobalHierarchyItems[i]));
                }
            }
            this.globalHierarchyItems = library.cloneObj(globalHierarhyItems);
        },
        filterChanged() {
            this.hideItems();
            let selectedLocation = this.selectedByGroup['LOCATION'] || 0;
            let selectedEntryPoint = this.selectedByGroup['ENTRY_POINT'] || 0;
            let selectedProgram = this.selectedByGroup['PROGRAM'] || 0;
            this.sDs.post('ec_setHierarchyFilter', selectedLocation, selectedEntryPoint, selectedProgram).then((response) => {
                if (response && response.status === 'success') {
                    let tmpRecordStore = recordStore();
                    if (tmpRecordStore && typeof tmpRecordStore.renewSubscriptions === 'function') tmpRecordStore.renewSubscriptions({ force: true });
                    let pspID = document.forms?.[0]?.perspectiveID?.value;
                    if (pspID) {
                        // following code for mainGrid
                        if (typeof mainGridAjaxCache !== 'undefined') mainGridAjaxCache = []; // force reload mainGrid when switch another to tab
                        if (typeof mainGridReloadVueGrid !== 'undefined') mainGridReloadVueGrid = true;
                        switch (pspID) {
                            case '104':
                                // do nothing, recordStore already called before
                                break;
                            case '32':
                                if (typeof doAction === 'function') doAction('aff_grid_vue');
                                break;
                            default:
                                if (typeof listEngineAction === 'function') listEngineAction('find');
                                break;
                        }
                    }
                }
            });
        }
    }
};

componentStore.initComponent(globalHierarchyFiltersCmp, globalHierarchyFiltersConfig);
export { globalHierarchyFiltersCmp, globalHierarchyFiltersConfig };
export default globalHierarchyFiltersCmp;

</script>

<style scoped>
    :deep(.global-hierarchy-filters) {
        display: flex;
        width: 300px;
    }
</style>
